import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import TechStackSection from "../components/TechStackSection";
import ModulesGrid from "../components/ModulesGrid";
import SectionHead from "../components/SectionHead";
import CtaBanner from "../components/CtaBanner";
import ProductImage from "../components/ProductImage";
import Icon from "../components/Icon";
import { IMAGES } from "../data/content";

function Product() {
  return (
    <>
      <PageHero
        eyebrow="Product"
        title="One app for attendance, leave, payroll and HR"
        subtitle="MPeoples HRMS is a mobile-based Human Resource Management System designed to simplify and digitize employee attendance and day-to-day HR activities."
      />

      <TechStackSection />

      <section className="section section--alt">
        <div className="container product-visual-grid">
          <ProductImage src={IMAGES.dashboardOverview} alt="MPeoples HRMS Admin Dashboard" frame="wide" />
          <div>
            <SectionHead
              eyebrow="Admin Dashboard"
              title="A single console for HR and management"
              subtitle="The web-based Admin Dashboard, complements the mobile application — letting HR and management centrally manage employees, branches, attendance, leave, permissions, tickets, payroll and reports."
            />
            <Link to="/solutions/admin-dashboard" className="link-arrow">
              See the Admin Dashboard solution <Icon name="arrow" size={14} />
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead
            eyebrow="Application modules"
            title="Everything branches from one app"
            subtitle="MPeoples HRMS consists of integrated modules that manage employee attendance and day-to-day HR activities through a centralized mobile application, supported by payroll and a web-based admin console."
          />
          <ModulesGrid limit={8} />
          <div className="section-cta-link">
            <Link to="/product/modules" className="link-arrow">
              View all 17 modules <Icon name="arrow" size={14} />
            </Link>
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default Product;
